const { useSelector } = require("react-redux");
const { reactLocalStorage } = require("reactjs-localstorage");

export const useClient = () => { 
    const user_type = reactLocalStorage.getObject('user_type', {});
     const {  client } = useSelector((state) => state?.user);
     let clientData = []
     if( (user_type === 3 || user_type === 4) && client?.length>0 )
     {
        clientData =[ client?.[0]?.value]
     }
    return clientData
 }
export const useFacility = () => { 
    const user_type = reactLocalStorage.getObject('user_type', {});
     const {  facility } = useSelector((state) => state?.user);
     let facilityData = []
     if( ( user_type === 4) && facility?.length>0 )
     {
        facilityData = [facility?.[0]?.value]
     }
    return facilityData
 }